import { promiseWorker } from "./index.ts";
import type api from "../../../app/src/ui/api/index.ts";
import type { Conditions } from "../../../common/types.ts";

const toUI = <Name extends keyof typeof api>(
	name: Name,
	args: Parameters<(typeof api)[Name]>,
	conditions: Conditions = {},
): Promise<ReturnType<(typeof api)[Name]>> => {
	if (process.env.NODE_ENV === "test") {
		return Promise.resolve(undefined as ReturnType<(typeof api)[Name]>);
	}

	// Pass the whole `conditions` object so each toUI bridge (main vs
	// worker-thread) can read the field that's meaningful in its context
	// — numeric `hostID` for main's WS map, string `userId` for the
	// thread's parentPort-to-registry hop. See `common/types.ts:Conditions`.
	//
	// Cast: the legacy worker-bridge type declares the second
	// arg as `targetHostID?: number`. Our bridges (server/util/toUI.ts and
	// toUIThread.ts) monkey-patch `postMessage` to accept `Conditions`
	// instead — see their patched signatures.
	return promiseWorker.postMessage(
		[name, ...args],
		conditions as unknown as number,
	);
};

export default toUI;
